import React from "react";
import "./galery.scss";
import img1 from "../../../assets/img/galery/1.svg";
import img2 from "../../../assets/img/galery/2.svg";
import img3 from "../../../assets/img/galery/3.svg";
import img4 from "../../../assets/img/galery/4.svg";
import img5 from "../../../assets/img/galery/5.svg";
import img6 from "../../../assets/img/galery/6.svg";
import img7 from "../../../assets/img/galery/7.svg";
import img8 from "../../../assets/img/galery/8.svg";
import img9 from "../../../assets/img/galery/9.svg";
import img10 from "../../../assets/img/galery/10.svg";
import img11 from "../../../assets/img/galery/11.svg";
import img12 from "../../../assets/img/galery/12.svg";
import img13 from "../../../assets/img/galery/13.svg";
import img14 from "../../../assets/img/galery/14.svg";
import img15 from "../../../assets/img/galery/15.svg";
import img16 from "../../../assets/img/galery/16.svg";
import img17 from "../../../assets/img/galery/17.svg";
import img18 from "../../../assets/img/galery/18.svg";
import img19 from "../../../assets/img/galery/19.svg";
import img20 from "../../../assets/img/galery/20.svg";
import img21 from "../../../assets/img/galery/21.svg";

function Galery() {
  return (
    <>
      <div className="row">
        <div className="col-4">
          <img src={img1} alt="" />
        </div>
        <div className="col-4">
          <img src={img2} alt="" />
        </div>
        <div className="col-4">
          <img src={img3} alt="" />
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <img src={img4} alt="" />
        </div>
        <div className="col-4">
          <img src={img5} alt="" />
        </div>
        <div className="col-4">
          <img src={img6} alt="" />
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <img src={img7} alt="" />
        </div>
        <div className="col-4">
          <img src={img8} alt="" />
        </div>
        <div className="col-4">
          <img src={img9} alt="" />
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <img src={img10} alt="" />
        </div>
        <div className="col-4">
          <img src={img11} alt="" />
        </div>
        <div className="col-4">
          <img src={img12} alt="" />
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <img src={img13} alt="" />
        </div>
        <div className="col-4">
          <img src={img14} alt="" />
        </div>
        <div className="col-4">
          <img src={img15} alt="" />
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <img src={img16} alt="" />
        </div>
        <div className="col-4">
          <img src={img17} alt="" />
        </div>
        <div className="col-4">
          <img src={img18} alt="" />
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <img src={img19} alt="" />
        </div>
        <div className="col-4">
          <img src={img20} alt="" />
        </div>
        <div className="col-4">
          <img src={img21} alt="" />
        </div>
      </div>

      <hr />
    </>
  );
}

export default Galery;
